<template>
  <v-select
    ref="select"
    v-bind:items="languages"
    v-model="item"
    @change="updateValue"
    item-text="name"
    item-value="id"
    :label="$t('school.LANGUAGE')"
    required
  >
    <template slot="selection" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
    <template slot="item" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
  </v-select>
</template>
<script>
  import {LanguageResource} from '../../api/language'
  export default {
    name: 'languageTextField',
    props: ['value'],
    data () {
      return {
        item: '',
        languages: []
      }
    },
    watch: {
      value (val) {
        this.item = val
      }
    },
    created () {
      if (this.value) {
        this.item = this.value
      }
    },
    mounted: function () {
      LanguageResource().get().then(
        response => {
          this.languages = response.data
        },
        error => {
          console.log('error getting languages', error)
        }
      )
    },
    methods: {
      updateValue: function (value) {
        this.$emit('input', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/LanguageTextField.vue